import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Amenities from "@/components/Amenities";
import Experiences from "@/components/Experiences";
import Pricing from "@/components/Pricing";
import Reviews from "@/components/Reviews";
import InquiryForm from "@/components/InquiryForm";
import BlogTeaser from "@/components/BlogTeaser";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import ScrollToTop from "@/components/ScrollToTop";

export default function HomePage() {
  React.useEffect(() => {
    document.title = "Mrinmaya | Homestay near Nandi Hills — Mountains, Movie Nights, Memories";
  }, []);

  return (
    <div data-testid="home-page" className="bg-mrn-bg">
      <Header />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Amenities />
        <Experiences />
        <Pricing />
        <Reviews />
        <InquiryForm />
        <BlogTeaser />
      </main>
      <Footer />
      <WhatsAppFAB />
      <ScrollToTop />
    </div>
  );
}
